const actions = {
  FETCH_USERLIST: "FETCH_USERLIST",
  FETCH_USERLIST_SUCCESS: "FETCH_USERLIST_SUCCESS",
  FETCH_USER_ACCESSION_LIST: "FETCH_USER_ACCESSION_LIST",
  FETCH_USER_ACCESSION_LIST_SUCCESS: "FETCH_USER_ACCESSION_LIST_SUCCESS",
  FETCH_PSM_CONFIG: "FETCH_PSM_CONFIG",
  FETCH_PSM_CONFIG_SUCCESS: "FETCH_PSM_CONFIG_SUCCESS",
  SAVE_PSM: "SAVE_PSM",
  SAVE_PSM_SUCCESS: "SAVE_PSM_SUCCESS",
  DELETE_PSM: "DELETE_PSM",
  PSM_LOADER: "PSM_LOADER",
  RESET: "RESET",
  SET_LOADING: "SET_PSM_LOADING",
  SET_LOADING_SUCCESS: "SET_PSM_LOADING_SUCCESS",
  FETCH_PSM_LIST: "FETCH_PSM_LIST",
  FETCH_PSM_LIST_SUCCESS: "FETCH_PSM_LIST_SUCCESS",
  FETCH_PSM_EXPORT: "FETCH_PSM_EXPORT",
  FETCH_PSM_EXPORT_SUCCESS: "FETCH_PSM_EXPORT_SUCCESS",
  RESET_USER_LIST: "RESET_USER_LIST",
  fetchPsmList: (payload) => ({
    type: actions.FETCH_PSM_LIST,
    payload,
  }),
  fetchExportContent: (payload, callback) => ({
    type: actions.FETCH_PSM_EXPORT,
    payload,
    callback
  }),
  fetchUserList: (payload) => ({
    type: actions.FETCH_USERLIST,
    payload,
  }),
  fetchUserDataList: (payload) => ({
    type: actions.FETCH_USER_ACCESSION_LIST,
    payload,
  }),
  savePsm: (psmList, grade, school, subject, userList) => ({
    type: actions.SAVE_PSM,
    psmList,
    grade,
    school,
    subject,
    userList,
  }),
  deletePsm: (pasmId, spinHandler) => ({
    type: actions.DELETE_PSM,
    pasmId,
    spinHandler,
  }),
  fetchPsmConfig: () => ({
    type: actions.FETCH_PSM_CONFIG,
  }),
  reset: () => ({
    type: actions.RESET,
  }),
  resetUserList: () => ({
    type: actions.RESET_USER_LIST,
  }),
};
export default actions;
